/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneSubscriptionDetailsDigital as ResolvedStandaloneSubscriptionDetailsDigital } from 'base/components/standalone/SubscriptionDetails/Digital';

export const SubscriptionDetailsDigital: typeof ResolvedStandaloneSubscriptionDetailsDigital = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneSubscriptionDetailsDigital {...props} />
        </ErrorBoundary>
    );
});

export type SubscriptionDetailsDigitalProps = PropsFromComponent<typeof SubscriptionDetailsDigital>;

/** @deprecated Use slot architecture instead */
export const SubscriptionDetailsDigitalWith = (extras: DynamicStandaloneExtras): typeof SubscriptionDetailsDigital => {
    return function SubscriptionDetailsDigital(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SubscriptionDetailsDigital');
        return <ResolvedStandaloneSubscriptionDetailsDigital {...mergeProps({ options: { theme } }, props)} />;
    }
}